module.exports = __webpack_public_path__ + "static/media/photoshop.44676395.svg";